const Config = {
    QiNiuUploadUrl: 'https://up-z0.qiniup.com', // 七牛上传地址
    QiNiuDownloadUrl: 'https://saas-console.biyela.cn', // 七牛下载地址
    topOffset: 48, // 页头高度
    IS_BIGDATA_ADMIN: '99',
    containerWidth: 1400, // 页面宽度
};

export default Config;
